import { render, staticRenderFns } from "./ValidationData.vue?vue&type=template&id=6bcfde5c&scoped=true&lang=pug&"
import script from "./ValidationData.vue?vue&type=script&lang=js&"
export * from "./ValidationData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcfde5c",
  null
  
)

export default component.exports